(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
/* WCAG 2.2.2: the moving ticker can be paused (it also pauses while a mouse is over it) */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-promo-pause]'); if (!b) return;
  var p = b.closest('.promo'), on = !p.classList.contains('is-paused');
  p.classList.toggle('is-paused', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
  b.firstElementChild.innerHTML = on ? '&#9654;' : '&#10074;&#10074;';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["book-pdp"]) return;
  try {
    
(() => {
  const root = document.querySelector('[data-bk]');
  if (!root) return;
  const app = (root.dataset.app || '').replace(/\/$/, '');
  const atf = document.querySelector('[data-atf]');

  // Flip through the sample book: Next page / Back, or tap the book; the next view's picture loads before it is needed.
  const flip = document.querySelector('[data-bk-flip]');
  if (flip) {
    const views = [...flip.querySelectorAll('[data-view]')];
    const back = flip.querySelector('[data-flip="-1"]'), next = flip.querySelector('[data-flip="1"]'), count = flip.querySelector('[data-flip-count]');
    let at = 0;
    const show = (n) => {
      at = (n + views.length) % views.length;
      views.forEach((v, k) => v.classList.toggle('is-on', k === at));
      const nx = views[at + 1] && views[at + 1].querySelector('img'); if (nx) nx.loading = 'eager';
      back.disabled = at === 0;
      next.innerHTML = at === views.length - 1 ? 'Start again' : 'Next page &rsaquo;';
      count.textContent = `${at + 1} / ${views.length}`;
    };
    back.addEventListener('click', () => show(at - 1));
    next.addEventListener('click', () => show(at + 1));
    views.forEach((v) => { const im = v.querySelector('img'); if (im) im.addEventListener('click', () => show(at + 1)); });
  }

  // The buy box goes straight to checkout (the buy button reads this when it's tapped), and its words follow the offer:
  // "Create my storybook" for one book, "Create my storybooks" for more.
  if (atf) {
    atf.setAttribute('data-after-add', 'checkout');
    const buttons = [...atf.querySelectorAll('.atf__atc, .atf__sticky-btn')];
    // The buy box marks the picked offer with is-on in its own click handler (no change event), so this looks right after it.
    const label = () => {
      const on = atf.querySelector('[data-offer].is-on');
      const many = Number((on && on.getAttribute('data-units')) || 1) > 1;
      buttons.forEach((b) => { b.textContent = b.textContent.replace(/(storybook|\bbook)s?\b/, (m, w) => (many ? w + 's' : w)); });
    };
    atf.addEventListener('click', (e) => { if (e.target.closest('[data-offer]')) setTimeout(label, 0); });
    label();
  }
  root.querySelectorAll('[data-bk-buy]').forEach((a) => a.addEventListener('click', (e) => {
    const buy = document.getElementById('buy');
    if (!buy) return;
    e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  const vids = [...root.querySelectorAll('[data-bk-vid]')];
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => {
    const v = e.target.querySelector('video');
    if (e.isIntersecting) v.play().catch(() => {}); else v.pause();
  }), { threshold: 0.5 }) : null;
  vids.forEach((box) => {
    const v = box.querySelector('video'), b = box.querySelector('[data-bk-sound]');
    if (io) io.observe(box);
    b.addEventListener('click', () => {
      vids.forEach((o) => { if (o !== box) { o.querySelector('video').muted = true; o.querySelector('[data-bk-sound]').hidden = false; } });
      v.muted = false; v.currentTime = 0; v.play().catch(() => {}); b.hidden = true;
    });
    v.addEventListener('click', () => { if (!v.muted) { v.muted = true; b.hidden = false; } });
  });

  // The extra: her photo, shrunk on the phone to a 2000 px JPEG, goes to the book maker, which paints her today and as a
  // little girl. The book's id goes on the cart, so the order carries on with this book.
  const input = root.querySelector('[data-bk-file]');
  const err = root.querySelector('[data-bk-error]');
  const box = root.querySelector('[data-bk-try]');
  const parts = { idle: root.querySelector('[data-bk-idle]'), busy: root.querySelector('[data-bk-busy]'), done: root.querySelector('[data-bk-done]') };
  const show = (which) => Object.entries(parts).forEach(([k, el]) => { el.hidden = k !== which; });
  const fail = (msg) => {
    show('idle');
    err.textContent = msg || "The photo didn't go through. Please try again.";
    err.hidden = false;
    input.value = '';
  };
  const painted = (r) => {
    root.querySelector('[data-bk-now]').src = r.now;
    root.querySelector('[data-bk-little]').src = r.little;
    show('done');
  };
  const shrink = async (file) => {
    try {
      const bmp = await createImageBitmap(file, { imageOrientation: 'from-image' });
      const k = Math.min(1, 2000 / Math.max(bmp.width, bmp.height));
      const c = document.createElement('canvas');
      c.width = Math.round(bmp.width * k);
      c.height = Math.round(bmp.height * k);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      return await new Promise((ok) => c.toBlob((b) => ok(b || file), 'image/jpeg', 0.86));
    } catch (e) {
      return file;
    }
  };
  const remember = (id) =>
    fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { book_id: id } }),
    }).catch(() => {});
  const status = (id) => fetch(app + '/api/pdp/start?id=' + encodeURIComponent(id), { cache: 'no-store' }).then((x) => x.json());
  // Painting takes about a minute: ask every 4 seconds, for up to 4 minutes.
  const wait = async (id) => {
    for (let i = 0; i < 60; i++) {
      const r = await status(id).catch(() => ({ waiting: true }));
      if (r.now && r.little) return painted(r);
      if (r.failed || r.error) return fail("We couldn't paint that photo. Please try one where your face is clear.");
      await new Promise((ok) => setTimeout(ok, 4000));
    }
    fail('The painting is taking longer than usual. Please try again.');
  };
  root.querySelectorAll('[data-bk-pick]').forEach((b) => b.addEventListener('click', () => input.click()));
  input.addEventListener('change', async () => {
    const file = input.files && input.files[0];
    if (!file) return;
    err.hidden = true;
    root.querySelector('[data-bk-own]').src = URL.createObjectURL(file);
    show('busy');
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try {
      const body = await shrink(file);
      const res = await fetch(app + '/api/pdp/start', { method: 'POST', headers: { 'Content-Type': body.type || 'image/jpeg' }, body });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.id) throw new Error(data.error);
      await remember(data.id);
      await wait(data.id);
    } catch (e) {
      fail(e && e.message);
    }
  });

  // Back on the page later with a painted photo in the cart: show it again.
  fetch('/cart.js', { credentials: 'same-origin' })
    .then((r) => r.json())
    .then((c) => {
      const id = c && c.attributes && c.attributes.book_id;
      if (!id) return;
      return status(id).then((r) => {
        if (r.now && r.little) painted(r);
        else if (r.waiting) {
          show('busy');
          wait(id);
        }
      });
    })
    .catch(() => {});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-tabs"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cat').forEach(function (root) {
  root.querySelectorAll('[data-tab]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = b.getAttribute('data-tab');
      root.querySelectorAll('[data-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      root.querySelectorAll('[data-tab-item]').forEach(function (x) { x.hidden = x.getAttribute('data-tab-item') !== t; });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-listicle"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-gl]');
  if (!root) return;
  var G = window.Groovd || {};
  function fm(c) { return G.formatMoney ? G.formatMoney(Number(c) || 0) : '$' + ((Number(c) || 0) / 100).toFixed(2); }

  /* Video slots: load and play only while on screen and on the active slide */
  var videos = [].slice.call(root.querySelectorAll('video.gl-g-media')), visible = new Set();
  function onActive(v) { var sl = v.closest('.gl-g-slide'), t = sl.parentNode; return Math.abs(sl.offsetLeft - t.scrollLeft) < t.clientWidth / 2; }
  function updateVideos() {
    videos.forEach(function (v) {
      var play = visible.has(v) && onActive(v) && document.visibilityState === 'visible';
      if (play) { if (!v.src && v.dataset.src) v.src = v.dataset.src; var p = v.play(); if (p && p['catch']) p['catch'](function () {}); }
      else if (!v.paused) v.pause();
    });
  }
  if (videos.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible['delete'](e.target); }); updateVideos(); }, { rootMargin: '200px 0px', threshold: 0.25 });
    videos.forEach(function (v) { io.observe(v); });
    document.addEventListener('visibilitychange', updateVideos);
  }

  /* Galleries: native scroll-snap swipe, dots, arrows */
  root.querySelectorAll('[data-gl-gallery]').forEach(function (g) {
    var track = g.querySelector('.gl-g-track'), slides = [].slice.call(track.children);
    var dots = [].slice.call(g.querySelectorAll('.gl-g-dot')), prev = g.querySelector('.gl-g-prev'), next = g.querySelector('.gl-g-next'), current = -1;
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth }); setTimeout(sync, 450); }
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (i === current) return; current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i === 0; if (next) next.disabled = i === slides.length - 1;
      updateVideos();
    }
    var raf, tm;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); clearTimeout(tm); tm = setTimeout(sync, 80); }, { passive: true });
    g.addEventListener('click', function (ev) { var b = ev.target.closest('[data-go]'); if (b) go(+b.getAttribute('data-go')); });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    track.addEventListener('keydown', function (ev) { if (ev.key === 'ArrowRight') { ev.preventDefault(); go(current + 1); } if (ev.key === 'ArrowLeft') { ev.preventDefault(); go(current - 1); } });
    sync();
  });

  /* Prices: every number comes from data attributes Shopify wrote (cents); this only formats them */
  function paint(box) {
    var chip = box.querySelector('.gl-chip.is-on'), src = chip || box;
    var price = Number(src.dataset.price) || 0, cmp = Number(src.dataset.compare) || 0, sale = cmp > price;
    box.querySelector('[data-gl-now]').textContent = fm(price);
    var was = box.querySelector('[data-gl-was]'), save = box.querySelector('[data-gl-save]');
    var badge = box.closest('.gl-product').querySelector('[data-gl-badge]');
    was.hidden = !sale; save.hidden = !sale; if (badge) badge.hidden = !sale;
    if (!sale) return;
    var pct = Math.round((cmp - price) * 100 / cmp);
    was.textContent = fm(cmp);
    save.textContent = save.dataset.word + ' ' + fm(cmp - price) + ' (' + pct + '%)';
    if (badge) badge.textContent = pct + '% ' + badge.textContent.replace(/^\d+%\s*/, '');
  }
  function paintAll() {
    root.querySelectorAll('[data-money]').forEach(function (el) { el.textContent = fm(el.getAttribute('data-money')); });
    root.querySelectorAll('[data-gl-box]').forEach(paint);
    if (G.reconvertCurrency) G.reconvertCurrency();
  }
  root.querySelectorAll('[data-gl-box]').forEach(function (box) {
    box.addEventListener('click', function (ev) {
      var chip = ev.target.closest('.gl-chip'); if (!chip || chip.disabled) return;
      box.querySelectorAll('.gl-chip').forEach(function (c) { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      paint(box);
    });
  });
  paintAll();
  document.addEventListener('gv:currency', paintAll);

  /* Cart: one line per product (Shopify merges a repeat add, so the old line of this product goes first) */
  var bar = root.querySelector('[data-gl-bar]'), toast = root.querySelector('[data-gl-toast]'), toastT;
  function say(msg) { toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 1800); }
  function refreshBar() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = G.visibleCount ? G.visibleCount(cart) : cart.item_count;
      root.querySelector('[data-gl-count]').textContent = n + ' ' + (n === 1 ? toast.dataset.one : toast.dataset.many);
      bar.classList.toggle('is-on', n > 0);
    })['catch'](function () {});
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function setLine(box) {
    var pid = Number(box.dataset.productId), chip = box.querySelector('.gl-chip.is-on');
    var vid = chip ? Number(chip.dataset.variant) : Number(box.dataset.variant), qty = chip ? (Number(chip.dataset.qty) || 1) : 1;
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var chain = Promise.resolve();
      (cart.items || []).forEach(function (it) { if (Number(it.product_id) === pid) chain = chain.then(function () { return post('/cart/change.js', { id: it.key, quantity: 0 }); }); });
      return chain;
    }).then(function () {
      var items = [{ id: vid, quantity: qty }];
      return G.addToCart ? G.addToCart(items) : post('/cart/add.js', { items: items });
    });
  }
  root.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-gl-action]'); if (!btn) return;
    var box = btn.closest('[data-gl-box]'); if (!box || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var action = btn.getAttribute('data-gl-action');
    setLine(box).then(function () {
      if (action === 'buy') { if (G.goAfterAdd) G.goAfterAdd('checkout'); else location.href = '/checkout'; return; }
      btn.removeAttribute('aria-busy'); say(toast.dataset.added); return refreshBar();
    })['catch'](function () { btn.removeAttribute('aria-busy'); say(toast.dataset.error); });
  });
  document.addEventListener('cart:added', function () { setTimeout(refreshBar, 300); });
  refreshBar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["groovd-track-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SVG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">';
  var EXTRA = {
    plane: SVG + '<path d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/></svg>',
    home: SVG + '<path d="M3 10.5L12 3l9 7.5"/><path d="M5 9.5V20a1 1 0 001 1h4v-6h4v6h4a1 1 0 001-1V9.5"/></svg>',
    copy: SVG + '<rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15H4a1 1 0 01-1-1V4a1 1 0 011-1h10a1 1 0 011 1v1"/></svg>',
    out: SVG + '<path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5"/></svg>'
  };
  var COUNTRY = { US: 'the US', GB: 'the UK', CA: 'Canada', AU: 'Australia', NZ: 'New Zealand', IE: 'Ireland', SG: 'Singapore', AE: 'the UAE' };
  var STEPS = [['ordered', 'Ordered', 'bag'], ['shipped', 'Shipped', 'box'], ['transit', 'On the way', 'plane'], ['ofd', 'Out for delivery', 'truck'], ['delivered', 'Delivered', 'home']];

  function esc(v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function loc() { return (window.gwLocale && window.gwLocale.dateLocale) || undefined; }
  function day(d) { try { return d.toLocaleDateString(loc(), { month: 'short', day: 'numeric' }); } catch (e) { return d.toDateString(); } }
  function time(d) { try { return d.toLocaleTimeString(loc(), { hour: 'numeric', minute: '2-digit' }); } catch (e) { return ''; } }
  function ymd(s) { var p = String(s).split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }
  // Carrier scans keep the clock time they were reported in (some US scans come stamped +08:00 with the local time), as
  // Track123 showed them. Shopify times (ending in Z) turn into the visitor's own time.
  function wall(iso) {
    var m = /^(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/.exec(iso || '');
    if (!m || /Z$/.test(iso)) return new Date(iso);
    return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
  }
  function when(iso) {
    var d = wall(iso); if (isNaN(d)) return '';
    var now = new Date(), y = new Date(now); y.setDate(now.getDate() - 1);
    var lbl = d.toDateString() === now.toDateString() ? 'Today' : d.toDateString() === y.toDateString() ? 'Yesterday' : day(d);
    return lbl + ', ' + time(d);
  }

  function init(root) {
    var api = root.getAttribute('data-api'), shop = root.getAttribute('data-shop');
    var card = root.querySelector('[data-trk-card]'), res = root.querySelector('[data-trk-result]');
    var copy = {}; try { copy = JSON.parse(root.querySelector('[data-trk-copy]').textContent); } catch (e) {}
    var icons = {}; var tpl = root.querySelector('[data-trk-icons]');
    if (tpl) Array.prototype.forEach.call(tpl.content.querySelectorAll('[data-i]'), function (n) { icons[n.getAttribute('data-i')] = n.innerHTML; });
    function ic(name) { return EXTRA[name] || icons[name] || ''; }
    var forms = { order: root.querySelector('[data-trk-form="order"]'), number: root.querySelector('[data-trk-form="number"]') };
    var mode = 'order';

    function setMode(m, focus) {
      mode = m; forms.order.hidden = m !== 'order'; forms.number.hidden = m !== 'number';
      if (focus) { var f = forms[m].querySelector('input'); if (f) f.focus(); }
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-trk-mode]'), function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-trk-mode'), true); });
    });

    function showErr(form, msg, bad) {
      var e = form.querySelector('.trk__err');
      Array.prototype.forEach.call(form.querySelectorAll('input'), function (i) { i.removeAttribute('aria-invalid'); });
      (bad || []).forEach(function (i) { i.setAttribute('aria-invalid', 'true'); });
      if (!msg) { e.hidden = true; e.textContent = ''; return; }
      e.innerHTML = ic('info') + '<span>' + esc(msg) + '</span>'; e.hidden = false;
    }

    function busy(form, on) {
      var b = form.querySelector('.trk__go'); if (!b) return;
      if (on) { b.setAttribute('aria-busy', 'true'); b.disabled = true; b.dataset.label = b.querySelector('span').textContent; b.querySelector('span').textContent = copy.loading || 'Looking it up'; }
      else { b.removeAttribute('aria-busy'); b.disabled = false; if (b.dataset.label) b.querySelector('span').textContent = b.dataset.label; }
    }

    function post(body) {
      body.shop = shop;
      return fetch(api, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok && !j.error) j.error = 'unavailable'; return j; }); })
        .catch(function () { return { error: 'unavailable' }; });
    }

    function lookup(form) {
      var data = {}, bad = [];
      Array.prototype.forEach.call(form.querySelectorAll('input'), function (i) { data[i.name] = i.value.trim(); if (!data[i.name]) bad.push(i); });
      if (bad.length) { showErr(form, mode === 'number' ? copy.err_missing_number : copy.err_missing, bad); bad[0].focus(); return; }
      showErr(form, '');
      busy(form, true);
      post(data).then(function (j) {
        busy(form, false);
        if (j && j.kind) { render(j); return; }
        var code = (j && j.error) || 'unavailable';
        var msg = code === 'mismatch' ? copy.err_mismatch : code === 'unknown_number' ? copy.err_unknown_number
          : code === 'too_many' ? copy.err_too_many : code === 'missing' ? copy.err_missing : copy.err_unavailable;
        showErr(form, msg, code === 'mismatch' || code === 'unknown_number' ? Array.prototype.slice.call(form.querySelectorAll('input')) : []);
      });
    }
    ['order', 'number'].forEach(function (k) {
      forms[k].addEventListener('submit', function (e) { e.preventDefault(); lookup(forms[k]); });
    });

    function parcelState(p) {
      var st = p.stage, at = p.deliveredAt ? wall(p.deliveredAt) : null;
      if (st === 'delivered') return { tone: 'done', icon: 'check', head: 'Delivered', sub: at ? 'Delivered on ' + day(at) + ' at ' + time(at) + '.' : 'Your parcel has been delivered.' };
      if (st === 'out_for_delivery') return { tone: '', icon: 'truck', head: 'Out for delivery', sub: 'It should arrive today.' };
      if (st === 'pickup') return { tone: 'warn', icon: 'info', head: 'Ready to collect', sub: 'The local carrier is holding it for you. Their note says where to collect it.' };
      if (st === 'problem') return { tone: 'warn', icon: 'info', head: 'Delivery problem', sub: 'The carrier reported a problem. Email us and we will sort it out.' };
      if (st === 'in_transit') {
        var c = COUNTRY[p.destCountry] || '';
        return { tone: '', icon: 'plane', head: 'On its way', sub: p.arrivedAt && c ? "It's in " + c + ' with the local carrier.' : "It's travelling to you." };
      }
      if (!p.scans && p.shippedAt) return { tone: '', icon: 'box', head: 'Shipped', sub: 'Your parcel has left our warehouse. Scans show up here once the carrier records them.' };
      return { tone: '', icon: 'box', head: 'Packed and ready', sub: 'The carrier has your parcel details and picks it up soon.' };
    }

    function steps(p, placedAt) {
      var done = { ordered: placedAt || true, shipped: p ? (p.shippedAt || (p.events.length ? p.events[p.events.length - 1].at : true)) : null,
        transit: p && p.inTransitAt, ofd: p && (p.outForDeliveryAt || p.deliveredAt), delivered: p && p.deliveredAt };
      var last = -1; STEPS.forEach(function (s, i) { if (done[s[0]]) last = i; });
      return '<ol class="trk__steps">' + STEPS.map(function (s, i) {
        var v = done[s[0]], cls = i < last || (i === last && s[0] === 'delivered') ? ' is-done' : i === last ? ' is-done is-now' : '';
        var date = typeof v === 'string' ? '<span class="trk__step-date">' + esc(day(v.length === 10 ? ymd(v) : wall(v))) + '</span>' : '';
        return '<li class="trk__step' + cls + '"><span class="trk__dot">' + ic(s[2]) + '</span><span class="trk__step-lbl">' + esc(s[1]) + '</span>' + date + '</li>';
      }).join('') + '</ol>';
    }

    function eta(r, p) {
      if (!r.eta || (p && p.stage === 'delivered')) return '';
      var from = ymd(r.eta.from), to = ymd(r.eta.to), today = new Date(); today.setHours(0, 0, 0, 0);
      var late = to < today;
      return '<div class="trk__eta' + (late ? ' trk__eta--late' : '') + '"><span class="trk__eta-lbl">' + (late ? 'Expected by' : 'Expected delivery') + '</span>'
        + '<b class="trk__eta-val">' + esc(late ? day(to) : day(from) + ' - ' + day(to)) + '</b></div>';
    }

    function history(p) {
      if (!p.events.length) return '<div class="trk__sec"><h3 class="trk__h3">Tracking history</h3><p class="trk__empty">' +
        (!p.scans && p.localUrl ? "The latest scans are on the carrier's site. Use the link below." : 'Scans show up here once the carrier records them.') + '</p></div>';
      var SHOW = 4, n = p.events.length;
      var li = p.events.map(function (e, i) {
        var meta = [e.place, when(e.at)].filter(Boolean).join(' · ');
        return '<li class="trk__ev"' + (i >= SHOW ? ' hidden' : '') + '><span class="trk__ev-text">' + esc(e.text) + '</span><span class="trk__ev-meta">' + esc(meta) + '</span></li>';
      }).join('');
      return '<div class="trk__sec"><h3 class="trk__h3">Tracking history</h3><ol class="trk__events' + (p.stage === 'delivered' ? ' trk__events--done' : '') + '">' + li + '</ol>'
        + (n > SHOW ? '<button class="trk__more" type="button" aria-expanded="false" data-more="' + n + '"><span>Show all ' + n + ' updates</span>' + ic('chev') + '</button>' : '') + '</div>';
    }

    function facts(p, r) {
      var rows = [];
      if (p.number) rows.push(['Tracking number', '<span class="trk__num">' + esc(p.number) + '</span><button class="trk__copy" type="button" data-copy="' + esc(p.number) + '">' + ic('copy') + '<span>Copy</span></button>']);
      if (p.localNumber && p.localNumber !== p.number) rows.push([p.localCarrier ? 'Local carrier' : 'Local tracking number',
        (p.localCarrier ? esc(p.localCarrier) + ' · ' : '') + '<span class="trk__num">' + esc(p.localNumber) + '</span>'
        + (p.localUrl ? '<a class="trk__link" href="' + esc(p.localUrl) + '" target="_blank" rel="noopener">' + esc(p.localCarrier ? 'Track with ' + p.localCarrier : 'Track with the carrier') + ic('out') + '</a>' : '')]);
      else if (p.localUrl && p.localNumber === p.number) rows.push(['Carrier', (p.localCarrier ? esc(p.localCarrier) + ' ' : '') + '<a class="trk__link" href="' + esc(p.localUrl) + '" target="_blank" rel="noopener">Track with the carrier' + ic('out') + '</a>']);
      if (r.order && r.order.destination) rows.push(['Delivering to', esc(r.order.destination)]);
      if (!rows.length) return '';
      return '<div class="trk__sec"><dl class="trk__facts">' + rows.map(function (x) { return '<div class="trk__fact"><dt>' + x[0] + '</dt><dd>' + x[1] + '</dd></div>'; }).join('') + '</dl></div>';
    }

    function items(list, title) {
      if (!list || !list.length) return '';
      return '<div class="trk__sec"><h3 class="trk__h3">' + esc(title) + '</h3><ul class="trk__items">' + list.map(function (it) {
        var img = it.image ? '<img src="' + esc(it.image) + '" alt="" width="60" height="60" loading="lazy">' : '<span class="trk__item-ph">' + ic('box') + '</span>';
        return '<li class="trk__item">' + img + '<span><span class="trk__item-name">' + esc(it.title) + '</span>' + (it.variant ? '<span class="trk__item-var">' + esc(it.variant) + '</span>' : '') + '</span><span class="trk__item-qty">&times;' + esc(it.qty) + '</span></li>';
      }).join('') + '</ul></div>';
    }

    function status(state, count) {
      return '<div class="trk__status"><span class="trk__disc' + (state.tone ? ' trk__disc--' + state.tone : '') + '">' + ic(state.icon) + '</span><div>'
        + (count ? '<p class="trk__count">' + esc(count) + '</p>' : '') + '<h2 class="trk__headline" tabindex="-1">' + esc(state.head) + '</h2><p class="trk__sub">' + esc(state.sub) + '</p></div></div>';
    }

    function render(r) {
      var placedAt = r.order ? r.order.placedAt : null, html = [];
      var again = r.kind === 'order' ? copy.again_order : copy.again_number;
      html.push('<div class="trk__bar"><button class="trk__again" type="button" data-again>' + ic('arrow') + '<span>' + esc(again || 'Track another order') + '</span></button>'
        + (r.order ? '<p class="trk__meta">Order <b>' + esc(r.order.name) + '</b> · ' + esc(day(new Date(r.order.placedAt))) + '</p>' : '') + '</div>');
      if (r.order && r.order.cancelledAt) {
        html.push('<article class="trk__box">' + status({ tone: 'warn', icon: 'info', head: 'Order cancelled', sub: 'This order was cancelled on ' + day(new Date(r.order.cancelledAt)) + '.' }) + '</article>');
      } else if (!r.parcels.length) {
        html.push('<article class="trk__box">' + status({ tone: 'wait', icon: 'bag', head: "We're packing it", sub: "You'll get an email with your tracking number when it ships." })
          + eta(r, null) + steps(null, placedAt) + items(r.waiting, 'In your order') + '</article>');
      } else {
        r.parcels.forEach(function (p, i) {
          var n = r.parcels.length;
          var st = parcelState(p);
          if (p.stage === 'in_transit' && r.eta && ymd(r.eta.to) < new Date(new Date().setHours(0, 0, 0, 0))) st.sub = "It's taking longer than usual. Email us and we will check on it.";
          html.push('<article class="trk__box">' + status(st, n > 1 ? 'Parcel ' + (i + 1) + ' of ' + n : '') + eta(r, p) + steps(p, placedAt)
            + history(p) + items(p.items, 'In this parcel') + facts(p, r) + '</article>');
        });
        if (r.waiting && r.waiting.length) html.push('<article class="trk__box">' + status({ tone: 'wait', icon: 'bag', head: 'Still to ship', sub: "These items ship separately. You'll get an email when they do." }) + items(r.waiting, 'Items') + '</article>');
      }
      var mail = esc(copy.email || 'support@thegroovd.com');
      html.push('<div class="trk__help"><span class="trk__help-ic">' + ic('chat') + '</span><p>Questions about your delivery? Email <a href="mailto:' + mail + '">' + mail + '</a>. ' + esc(copy.hours || '') + '</p></div>');
      res.innerHTML = html.join('');
      card.hidden = true; res.hidden = false;
      var h = res.querySelector('.trk__headline'); if (h) h.focus({ preventScroll: true });
      var rt = res.getBoundingClientRect().top;
      if (rt < 0 || rt > window.innerHeight * 0.6) window.scrollTo({ top: Math.max(0, rt + window.pageYOffset - 12), behavior: 'smooth' });
    }

    res.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t) return;
      if (t.hasAttribute('data-again')) { res.hidden = true; res.innerHTML = ''; card.hidden = false; var f = forms[mode].querySelector('input'); if (f) f.focus(); return; }
      if (t.hasAttribute('data-more')) {
        var open = t.getAttribute('aria-expanded') !== 'true';
        Array.prototype.forEach.call(t.parentNode.querySelectorAll('.trk__ev'), function (li, i) { if (i >= 4) li.hidden = !open; });
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.querySelector('span').textContent = open ? 'Show fewer' : 'Show all ' + t.getAttribute('data-more') + ' updates';
        return;
      }
      if (t.hasAttribute('data-copy')) {
        var v = t.getAttribute('data-copy'), lbl = t.querySelector('span');
        var done = function () { lbl.textContent = 'Copied'; setTimeout(function () { lbl.textContent = 'Copy'; }, 1800); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(v).then(done, function () {});
      }
    });

    // Links in shipping emails (and old /apps/track123 links once they forward here) carry the tracking number.
    var q = new URLSearchParams(location.search), num = q.get('nums') || q.get('number') || q.get('tracking');
    if (num) { setMode('number'); forms.number.querySelector('input').value = num.split(',')[0].trim(); lookup(forms.number); }
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-trk]'), init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var hdr = document.getElementById('SiteHeader'); if (!hdr) return;

  /* Desktop mega menu: hover intent, click, Escape, click outside. */
  var btn = hdr.querySelector('[data-mega-toggle]'), panel = hdr.querySelector('[data-mega-panel]');
  var openT, closeT;
  function setMega(open) {
    if (!btn || !panel) return;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (btn && panel) {
    var hoverable = window.matchMedia('(hover: hover) and (min-width: 1000px)');
    btn.addEventListener('click', function (e) { e.preventDefault(); clearTimeout(closeT); setMega(panel.hidden); });
    [btn, panel].forEach(function (el) {
      el.addEventListener('mouseenter', function () { if (!hoverable.matches) return; clearTimeout(closeT); openT = setTimeout(function () { setMega(true); }, 80); });
      el.addEventListener('mouseleave', function () { if (!hoverable.matches) return; clearTimeout(openT); closeT = setTimeout(function () { setMega(false); }, 240); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { setMega(false); btn.focus(); } });
    document.addEventListener('click', function (e) { if (!panel.hidden && !hdr.contains(e.target)) setMega(false); });
    panel.addEventListener('focusout', function (e) { if (e.relatedTarget && !panel.contains(e.relatedTarget) && e.relatedTarget !== btn) setMega(false); });
  }

  /* Phone drawer: full screen, locks page scroll, closes on Escape or when the viewport grows. */
  var t = hdr.querySelector('[data-nav-toggle]'), nav = document.getElementById('MobileNav');
  function setDrawer(open) {
    if (!t || !nav) return;
    nav.hidden = !open;
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('nav-open', open);
    if (open) { var c = nav.querySelector('[data-nav-close]'); if (c) c.focus(); } else { t.focus(); }
  }
  if (t && nav) {
    t.addEventListener('click', function () { setDrawer(nav.hidden); });
    nav.querySelectorAll('[data-nav-close]').forEach(function (c) { c.addEventListener('click', function () { setDrawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !nav.hidden) setDrawer(false); });
    var wide = window.matchMedia('(min-width: 1000px)');
    (wide.addEventListener ? wide.addEventListener('change', onWide) : wide.addListener(onWide));
    function onWide(m) { if (m.matches && !nav.hidden) setDrawer(false); }
  }

  /* Country picker. A choice is kept for the visit: gw-currency.js and the flag painter (global.js) read
     gwVisitorCountry before the IP lookup. A country Shopify sells in with its own currency also moves the
     Shopify market (?country=XX), so the checkout charges that currency; the rest go back to the US market. */
  var cdlg = document.getElementById('CountryPicker');
  if (cdlg && typeof cdlg.showModal === 'function') {
    var cq = cdlg.querySelector('[data-country-search]');
    var current = function () {
      try { var c = JSON.parse(sessionStorage.getItem('gwVisitorCountry') || 'null'); if (c && c.code) return String(c.code).toUpperCase(); } catch (e) {}
      return String((window.gvCurrency && window.gvCurrency.country) || (window.GW_LOC && window.GW_LOC.country) || 'US').toUpperCase();
    };
    var filter = function () {
      var q = (cq.value || '').trim().toLowerCase();
      cdlg.querySelectorAll('[data-country-group]').forEach(function (g) {
        var shown = 0;
        g.querySelectorAll('[data-country]').forEach(function (b) {
          var hit = !q || b.getAttribute('data-name').toLowerCase().indexOf(q) > -1 || b.getAttribute('data-country').toLowerCase() === q;
          b.parentNode.hidden = !hit; if (hit) shown++;
        });
        g.hidden = !shown;
      });
    };
    document.querySelectorAll('[data-country-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = current();
        cdlg.querySelectorAll('[data-country]').forEach(function (x) { var on = x.getAttribute('data-country') === c; x.classList.toggle('is-on', on); if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
        cq.value = ''; filter();
        cdlg.showModal();
      });
    });
    cdlg.addEventListener('click', function (e) { if (e.target === cdlg || e.target.closest('[data-country-close]')) cdlg.close(); });
    cq.addEventListener('input', filter);
    cdlg.querySelectorAll('[data-country]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-country'), L = window.GW_LOC || {}, markets = L.markets || {}, now = String(L.country || 'US').toUpperCase();
        try { sessionStorage.setItem('gwVisitorCountry', JSON.stringify({ code: code, name: b.getAttribute('data-name'), picked: true })); sessionStorage.removeItem('gwMarketSwitch'); } catch (e) {}
        var target = markets[code] ? code : (markets.US ? 'US' : now);
        var u = new URL(location.href);
        u.searchParams['delete']('gv_currency'); u.searchParams['delete']('country');
        if (target !== now) u.searchParams.set('country', target);
        if (u.toString() === location.href) location.reload(); else location.assign(u.toString());
      });
    });
  }

  document.addEventListener('cart:added', function () {
    var c = document.querySelector('[data-cart-count]'); if (!c) return;
    fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (cart) { var n = window.Groovd && window.Groovd.visibleCount ? window.Groovd.visibleCount(cart) : cart.item_count; c.textContent = n; c.hidden = n === 0; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(function () {
function initCart(root) {
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]'); if (!b) return;
    var line = Number(b.getAttribute('data-line')), input = root.querySelector('input[data-qty="' + line + '"]');
    var q = Math.max(0, Number(input.value) + Number(b.getAttribute('data-step')));
    input.value = q; b.disabled = true;
    window.Groovd.request(window.routes.cart_change_url + '.js', { line: line, quantity: q }).then(function () { location.reload(); });
  });
  /* typed quantities submit the cart form; only the quantity boxes (the protection switch must never submit it, 14.10.2026) */
  root.querySelectorAll('input[data-qty]').forEach(function (i) { i.addEventListener('change', function () { var u = root.querySelector('[data-update]'); u && u.click(); }); });


  /* Cart upsell (23.10.2026): Groovd(R) Bear Backpack card. The Add button, "Add their name" with a live preview,
     and "Ship everything together" for a named backpack (unticking adds the $5 "Ship in two parcels" line). */
  (function () {
    var rq = window.Groovd && window.Groovd.request; if (!rq) return;
    function go() { refreshCart(root); }
    function track(name, props) { props = props || {}; props.ui = 'button'; var t = 0; (function w() { var p = window.posthog; if (p && typeof p.capture === 'function') { try { p.capture(name, props); } catch (e) {} return; } if (++t < 100) setTimeout(w, 100); })(); }
    var feeKey = root.getAttribute('data-fee-key'), feeQty = Number(root.getAttribute('data-fee-qty') || 0), named = root.getAttribute('data-bp-has-named') === 'true';
    var keys = (root.getAttribute('data-bp-keys') || '').split(',').filter(Boolean);
    function zero(list) { var u = {}; list.forEach(function (k) { if (k) u[k] = 0; }); return rq(window.routes.cart_update_url + '.js', { updates: u }); }
    /* the fee belongs only with a named backpack, and only once */
    if (feeQty > 0 && !named) { zero([feeKey]).then(go)['catch'](function () {}); return; }
    if (feeQty > 1) { rq(window.routes.cart_change_url + '.js', { id: feeKey, quantity: 1 }).then(go)['catch'](function () {}); return; }
    var card = root.querySelector('[data-bp-row]'); if (!card) return;
    /* the buying journey (owner 27.10.2026, "Buying experience needs to be seamless"): after + Add the name field and the card's own
       Check out are in view together, so a name is one tap away and so is checking out without one ("doesn't feel seemless now for
       someone who doesn't want to add the name"); after the name, the Check out. The field is not focused, so no keyboard pops up over
       Check out. The step is kept across the in-place refresh in sessionStorage gw_bp_next. */
    (function () {
      var next = ''; try { next = sessionStorage.getItem('gw_bp_next') || ''; sessionStorage.removeItem('gw_bp_next'); } catch (e) {}
      var co = card.querySelector('[data-bp-checkout]'), top = next === 'name' ? card.querySelector('[data-bp-input]') : next === 'checkout' ? co : null;
      if (!top) return;
      if (next === 'name') { card.classList.add('is-next-name'); top = card.querySelector('.cart__bp-more') || top; }
      setTimeout(function () {
        var a = top.getBoundingClientRect(), b = (co || top).getBoundingClientRect(), vh = window.innerHeight;
        window.scrollTo({ top: Math.max(0, window.pageYOffset + a.top - Math.max(12, (vh - (b.bottom - a.top)) / 2)), behavior: 'smooth' });
      }, 60);
    })();
    function nextStep(v) { try { if (v) sessionStorage.setItem('gw_bp_next', v); else sessionStorage.removeItem('gw_bp_next'); } catch (e) {} }
    if (root.getAttribute('data-bp-arm') === 'without' && !keys.length) return;
    if (!keys.length) { var seen = false; try { seen = sessionStorage.getItem('gw_bp_seen_button') === '1'; sessionStorage.setItem('gw_bp_seen_button', '1'); } catch (e) {} if (!seen) track('cart_upsell_viewed', { upsell: 'bear_backpack' }); }
    function busy() { card.classList.add('is-busy'); }
    function idle() { card.classList.remove('is-busy'); }
    var area = card.querySelector('[data-bp-name-area]'), pv = card.querySelector('[data-bp-pvname]'), input = card.querySelector('[data-bp-input]');
    var save = card.querySelector('[data-bp-save]'), err = card.querySelector('[data-bp-err]'), nbox = card.querySelector('[data-bp-named-box]');
    /* The name box is open from the start (owner 23.10.2026: "the add their name thing already opened so they can see how cute it is").
       Nothing is added until a name is: "Add name", Enter, ticking "Add their name", or "+ Add" with a name typed all add the
       personalized backpack. */
    function addName() {
      if (!input) return false;
      var n = (input.value || '').replace(/\s+/g, ' ').trim(), ok = true;
      try { ok = new RegExp("^\\p{L}[\\p{L} .'-]{0,11}$", 'u').test(n); } catch (e) { ok = /^[A-Za-z][A-Za-z .'-]{0,11}$/.test(n); }
      if (!ok) { err.hidden = false; input.focus(); return false; }
      save.disabled = true; busy(); nextStep('checkout'); track('cart_upsell_added', { upsell: 'bear_backpack', named: true });
      zero(keys).then(function () { return rq(window.routes.cart_add_url + '.js', { items: [{ id: Number(card.getAttribute('data-named')), quantity: 1, properties: { "Child's name": n } }] }); })
        .then(function () { return rq(window.routes.cart_update_url + '.js', { attributes: { 'Shipping': 'Ship everything together' } }); })
        .then(go)['catch'](function () { nextStep(''); save.disabled = false; if (nbox) nbox.checked = named; idle(); });
      return true;
    }
    function addPlain() {
      if (input && (input.value || '').trim()) { addName(); return; }
      busy(); nextStep('name'); track('cart_upsell_added', { upsell: 'bear_backpack', named: false }); return rq(window.routes.cart_add_url + '.js', { items: [{ id: Number(card.getAttribute('data-plain')), quantity: 1 }] }).then(go)['catch'](function () { nextStep(''); idle(); });
    }
    function removeAll() { busy(); track('cart_upsell_removed', { upsell: 'bear_backpack', named: named }); return zero(keys.concat(feeQty > 0 ? [feeKey] : [])).then(go)['catch'](idle); }
    var addBtn = card.querySelector('[data-bp-add]'); if (addBtn) addBtn.addEventListener('click', addPlain);
    var rmBtn = card.querySelector('[data-bp-remove]'); if (rmBtn) rmBtn.addEventListener('click', removeAll);
    /* live preview: the name in the embroidery spot, shrunk to fit the panel. It shows once the script font has loaded, so the
       name never jumps from a stand-in font. */
    function fit() {
      if (!pv) return; var box = pv.parentNode.getBoundingClientRect().width; if (!box) return;
      var size = box * 0.115; pv.style.fontSize = size + 'px';
      for (var i = 0; i < 30 && pv.scrollWidth > box * 0.34; i++) { size *= 0.94; pv.style.fontSize = size + 'px'; }
    }
    /* sample name: types itself, deletes, types the next (owner 27.10.2026); stops when a name is typed or the card is re-drawn */
    var SAMPLES = ['Emma', 'Leo', 'Mila', 'Noah'], demo = 0;
    function demoStop() { if (demo) { clearTimeout(demo); demo = 0; } }
    function demoRun() {
      demoStop(); if (!pv) return;
      pv.classList.add('is-sample');
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { pv.textContent = SAMPLES[0]; fit(); return; }
      var w = 0, i = 0, dir = 1;
      (function tick() {
        if (!pv.isConnected) { demo = 0; return; }
        var name = SAMPLES[w % SAMPLES.length];
        if (dir > 0) { i++; if (i > name.length) { i = name.length; dir = -1; demo = setTimeout(tick, 1500); return; } }
        else { i--; if (i < 0) { i = 0; dir = 1; w++; demo = setTimeout(tick, 380); return; } }
        pv.textContent = name.slice(0, i) || '\u200b'; fit();
        demo = setTimeout(tick, dir > 0 ? 160 : 75);
      })();
    }
    function showName(v) { if (!pv) return; var t = (v || '').trim(); if (!t) { if (!demo) demoRun(); return; } demoStop(); pv.classList.remove('is-sample'); pv.textContent = t; fit(); }
    function fontReady(cb) {
      var done = false; function ready() { if (!done) { done = true; cb(); } }
      setTimeout(ready, 2500);
      function load() { try { if (document.fonts.check('700 20px "Dancing Script"')) return ready(); document.fonts.load('700 20px "Dancing Script"').then(ready, ready); } catch (e) { ready(); } }
      var l = document.getElementById('gw-bp-font');
      if (!l) { l = document.createElement('link'); l.id = 'gw-bp-font'; l.rel = 'stylesheet'; l.href = 'https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap'; l.onload = load; l.onerror = ready; document.head.appendChild(l); }
      else if (l.sheet) load(); else { l.addEventListener('load', load); l.addEventListener('error', ready); }
    }
    if (pv) fontReady(function () { showName(input ? input.value : pv.textContent); pv.classList.add('is-ready'); });
    window.gwBpFit = fit;
    if (!window.gwBpFitOn) { window.gwBpFitOn = true; window.addEventListener('resize', function () { if (window.gwBpFit) window.gwBpFit(); }); }
    if (nbox) nbox.addEventListener('change', function () {
      if (nbox.checked && !named) { if (!addName()) nbox.checked = false; return; }
      if (!nbox.checked && named) {
        /* a named backpack back to the standard one */
        busy(); track('cart_upsell_name_removed', { upsell: 'bear_backpack' });
        zero(keys.concat(feeQty > 0 ? [feeKey] : [])).then(function () { return rq(window.routes.cart_add_url + '.js', { items: [{ id: Number(card.getAttribute('data-plain')), quantity: 1 }] }); }).then(go)['catch'](function () { nbox.checked = true; idle(); });
      }
    });
    if (input) {
      input.addEventListener('input', function () { err.hidden = true; showName(input.value); });
      input.addEventListener('focus', function () { var s = false; try { s = sessionStorage.getItem('gw_bp_name_focus') === '1'; sessionStorage.setItem('gw_bp_name_focus', '1'); } catch (e) {} if (!s) track('cart_upsell_name_opened', { upsell: 'bear_backpack' }); });
      save.addEventListener('click', addName);
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addName(); } });
    }
    var tog = card.querySelector('[data-bp-together-box]');
    if (tog) tog.addEventListener('change', function () {
      var on = tog.checked, wrap = card.querySelector('[data-bp-together]'); busy();
      track('ship_together_toggled', { on: on });
      var req = on ? zero([feeKey]) : rq(window.routes.cart_add_url + '.js', { items: [{ id: Number(wrap.getAttribute('data-fee')), quantity: 1 }] });
      req.then(function () { return rq(window.routes.cart_update_url + '.js', { attributes: { 'Shipping': on ? 'Ship everything together' : 'Two parcels' } }); })
        .then(go)['catch'](function () { tog.checked = !on; idle(); });
    });
  })();

  /* Cart test 2 (17.10.2026): protection switch alone ('protect') vs free-shipping bar + switch ('both'). The side was picked
     before paint (data-arm). */
  var G = window.Groovd; if (!G || !G.cartArm) return;
  function post(url, body) { return G.request(url, body); }
  function reload() { location.reload(); }
  function ph(fn) { var t = 0; (function go() { var p = window.posthog; if (p && typeof p.capture === 'function') { try { fn(p); } catch (e) {} return; } if (++t < 100) setTimeout(go, 100); })(); }
  /* only the protection line left (the visitor removed everything else): take it out too */
  var orphan = root.querySelector('[data-prot-orphan]');
  if (orphan) { post(window.routes.cart_change_url + '.js', { id: orphan.getAttribute('data-prot-orphan'), quantity: 0 })['catch'](function () {}); return; }
  var lines = root.querySelector('[data-arm]'); if (!lines) return;
  var arm = lines.getAttribute('data-arm'), prot = root.querySelector('[data-prot]');
  var qty = prot ? Number(prot.getAttribute('data-prot-qty')) : 0, key = prot ? prot.getAttribute('data-key') : '', vid = prot ? Number(prot.getAttribute('data-variant')) : 0;
  /* exposure: once per tab per side; the side also goes on the cart so the order carries it (note attributes _cart_test =
     the side, _cart_test_id). Cart test 6 (28.10.2026): no backpack card ('none', the control) vs the card under the order summary
     and its Check out button ('below'), id 'ct6' ('ct6-qa' on a ?bp_pos=, ?bp_test= or ?cart_test= QA link).
     Earlier: 'ct5' (none vs above vs below, 27.10-28.10.2026), 'ct4' (above vs below, 25.10-27.10.2026), 'ct3' (the backpack card 'with' vs 'without', 23.10-25.10.2026),
     'ct2' (17.10-22.10.2026), then 'ct2-ended' until test 3 started. */
  var bpArm = root.getAttribute('data-bp-pos') || 'above';
  var qa = /[?&](bp_pos|bp_test|cart_test)=/.test(location.search), tid = qa ? 'ct6-qa' : 'ct6-ended';
  ph(function (p) {
    p.register({ cart_test: bpArm });
    var k = 'gw_ct6_seen_' + bpArm, seen = false;
    try { seen = sessionStorage.getItem(k) === '1'; } catch (e) {}
    if (!seen) { p.capture('cart_test_viewed', { test: tid, qa: qa, arm: bpArm, backpack_in_cart: root.getAttribute('data-bp-any') === 'true', protection_in_cart: qty > 0, market: (window.GW_LOC || {}).country }); try { sessionStorage.setItem(k, '1'); } catch (e) {} }
  });
  if (lines.getAttribute('data-attr') !== bpArm || lines.getAttribute('data-attr-id') !== tid) post(window.routes.cart_update_url + '.js', { attributes: { _cart_test: bpArm, _cart_test_id: tid } })['catch'](function () {});
  /* protection the visitor did not switch on themselves (added by the 14.10 switched-on default) comes out */
  if (qty > 0 && !G.protDefaultOn() && !(G.protOptedIn && G.protOptedIn())) { post(window.routes.cart_change_url + '.js', { id: key, quantity: 0 }).then(reload)['catch'](function () {}); return; }
  if (qty > 1) { post(window.routes.cart_change_url + '.js', { id: key, quantity: 1 }).then(reload); return; }
  /* a cart made before this visitor's coin flip (or on another page path): add the protection once, where it starts switched on */
  if ((arm === 'protect' || arm === 'both') && qty === 0 && vid && G.protDefaultOn() && !G.protOptedOut()) {
    var tried = true; try { tried = sessionStorage.getItem('gw_prot_auto') === '1'; sessionStorage.setItem('gw_prot_auto', '1'); } catch (e) {}
    if (!tried) { post(window.routes.cart_add_url + '.js', { items: [{ id: vid, quantity: 1 }] }).then(reload)['catch'](function () {}); return; }
  }
  var box = root.querySelector('[data-prot-toggle]');
  if (box) box.addEventListener('change', function () {
    var on = box.checked; box.disabled = true; prot.classList.add('is-busy');
    G.setProtOptOut(!on);
    ph(function (p) { p.capture('shipping_protection_toggled', { on: on, arm: arm }); });
    var req = on ? post(window.routes.cart_add_url + '.js', { items: [{ id: vid, quantity: 1 }] }) : post(window.routes.cart_change_url + '.js', { id: key, quantity: 0 });
    req.then(reload)['catch'](function () { box.checked = !on; box.disabled = false; prot.classList.remove('is-busy'); });
  });
}

/* Backpack card changes re-draw the cart section in place (Section Rendering API) instead of reloading the page, so the page
   doesn't flash or jump (owner 23.10.2026: "the page glitches out weirdly when you save the name"). The section's inline
   scripts run again as on a page load. When the order has just reached free shipping, the green bar above the order summary
   is highlighted and scrolled to the middle of the screen. Any failure falls back to a reload. */
function refreshCart(root) {
  var id = root.getAttribute('data-section-id'), wasDone = !!root.querySelector('[data-ship].is-done');
  if (!id || !window.fetch || !window.DOMParser) { location.reload(); return; }
  fetch(window.routes.cart_url + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin', cache: 'no-store' })
    .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
    .then(function (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart]');
      if (!fresh || !root.parentNode) throw new Error('no cart section');
      fresh = document.importNode(fresh, true);
      root.parentNode.replaceChild(fresh, root);
      Array.prototype.forEach.call(fresh.querySelectorAll('script'), function (old) {
        var s = document.createElement('script'); s.textContent = old.textContent; old.parentNode.replaceChild(s, old);
      });
      initCart(fresh);
      try { document.dispatchEvent(new CustomEvent('cart:added')); } catch (e) {}
      var bar = fresh.querySelector('[data-ship].is-done');
      if (bar && !wasDone && bar.offsetParent) {
        bar.classList.add('is-new');
        try { bar.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { bar.scrollIntoView(false); }
      }
    })['catch'](function () { location.reload(); });
}
window.gwRefreshCart = refreshCart;

document.querySelectorAll('[data-cart]').forEach(initCart);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.querySelectorAll('[data-sort-select]').forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var form = root.querySelector('[data-form]');
    if (!form) return;
    var fm = window.Groovd.formatMoney;
    var variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    var input = form.querySelector('[data-variant-input]');
    var state = { id: Number(input.value), qty: 1, price: 0, compare: 0, kids: 1 };
    /* Kids ladder, owner 16.10.2026: Shopify charges what CheckoutChamp charges, $25 / $23 / $22 / $20 per set for 2 / 3 / 4 / 5+ kids.
       The real price comes from the four automatic discounts "Groovd copybooks quantity ladder - N+ sets" (percent off each set,
       rounded per set as Shopify does); this only shows that same price on the page before checkout. */
    var LADDER = { 2: 0.1639, 3: 0.2308, 4: 0.2643, 5: 0.3312 }, LADDER_IDS = [42566240698588, 59478965649753];
    function unitPrice() { var k = Math.min(state.kids, 5), p = state.qty === 1 && LADDER_IDS.indexOf(state.id) > -1 && k >= 2 ? LADDER[k] : 0; return state.price - Math.round(state.price * p); }

    function readTier(t) {
      return { id: Number(t.getAttribute('data-id')), qty: Number(t.getAttribute('data-qty')) || 1, price: Number(t.getAttribute('data-price')), compare: Number(t.getAttribute('data-compare')) || 0, available: t.getAttribute('data-available') === 'true' };
    }
    var firstOn = root.querySelector('.tier.is-on') || root.querySelector('.tier');
    if (firstOn) { var t0 = readTier(firstOn); state.id = t0.id; state.qty = t0.qty; state.price = t0.price; state.compare = t0.compare; firstOn.classList.add('is-on'); var r0 = firstOn.querySelector('input'); if (r0) r0.checked = true; }
    else { var v0 = variants.find(function (v) { return v.id === state.id; }) || variants[0]; state.price = v0.price; state.compare = v0.compare_at_price || 0; }

    /* Price display split (owner 20.10.2026): arm bs shows the SAME sale display as the control, but its compare price is the
       same books bought one by one (4 x the single-book price, times the kids), labelled "Bought separately" (owner 20.10.2026:
       "as close to the original as possible"). Single books in arm bs: compare = 0, no badge. */
    var bsOn = root.hasAttribute('data-bs-ok') && document.documentElement.getAttribute('data-gv-price') === 'bs';
    function bsUnits() { var t = root.querySelector('.tier.is-on'); return t ? Number(t.getAttribute('data-units')) || 1 : 1; }
    function bsSingle() { var t = root.querySelector('.tier[data-units="1"]'); return t ? Number(t.getAttribute('data-price')) || 0 : 0; }
    function render() {
      var price = unitPrice() * state.kids, compare = state.compare * state.kids;
      var bsSet = false, bsSep = 0;
      if (bsOn) { var bsOne = bsSingle(), bsU = bsUnits(); compare = 0; if (bsOne > 0 && bsU > 1) { bsSet = true; bsSep = bsOne * bsU * state.kids; } if (bsSet && bsSep > price) compare = bsSep; root.setAttribute('data-bs-done', ''); }
      root.querySelectorAll('[data-bs-label]').forEach(function (el) { el.hidden = !bsSet; el.textContent = 'All ' + bsUnits() + ' books' + (state.kids > 1 ? ' \u00d7 ' + state.kids : '') + ':'; });
      root.querySelectorAll('[data-bs-line]').forEach(function (el) {
        el.hidden = !(bsSet && bsSep > price); if (el.hidden) return;
        var a = el.querySelector('[data-bs-sep]'), b = el.querySelector('[data-bs-save]'), c = el.querySelector('[data-bs-pct]');
        if (a) a.textContent = fm(bsSep); if (b) b.textContent = fm(bsSep - price); if (c) c.textContent = Math.round((bsSep - price) * 100 / bsSep);
      });
      root.querySelectorAll('[data-price-now]').forEach(function (el) { el.textContent = fm(price); });
      /* sticky total = the price shown + each ticked add-on as shown (gw-currency rounds each part, like the checkout) */
      var parts = [price];
      root.querySelectorAll('[data-addon]:checked').forEach(function (cb) { parts.push(Number(cb.getAttribute('data-price')) || 0); });
      var total = window.gwFormatSum ? window.gwFormatSum(parts) : fm(parts.reduce(function (a, b) { return a + b; }, 0));
      root.querySelectorAll('[data-total]').forEach(function (el) { el.textContent = total; });
      root.querySelectorAll('[data-price-was-amount]').forEach(function (el) { el.textContent = fm(compare); });
      root.querySelectorAll('[data-price-was]').forEach(function (el) { el.hidden = !(compare > price); });
      root.querySelectorAll('[data-price-save]').forEach(function (el) {
        var block = el.closest('[data-price-block]'); var mode = block.getAttribute('data-save-mode'); var label = block.getAttribute('data-save-label');
        el.hidden = !(compare > price);
        el.textContent = mode === 'amount' ? label + ' ' + fm(compare - price) : label + ' ' + Math.round((compare - price) * 100 / compare) + '%';
      });
      var kt = root.querySelector('[data-kids-total]');
      if (kt) { kt.hidden = state.kids < 2; kt.textContent = state.kids + ' sets, ' + fm(price) + ' in total' + (unitPrice() < state.price ? ' (' + fm(unitPrice()) + ' per set)' : ''); }
      /* round % badge, "You save" line and the offer-style sticky bar (lander elements) */
      var sale = compare > price, pctNow = sale ? Math.round((compare - price) * 100 / compare) : 0;
      root.querySelectorAll('[data-burst]').forEach(function (el) { el.hidden = !sale; var b = el.querySelector('[data-burst-pct]'); if (b) b.textContent = pctNow + '%'; });
      root.querySelectorAll('[data-you-save]').forEach(function (el) { el.hidden = !sale; var a = el.querySelector('[data-save-amount]'); if (a) a.textContent = fm(compare - price); var p = el.querySelector('[data-save-pct]'); if (p) p.textContent = pctNow; });
      root.querySelectorAll('[data-sticky-pct]').forEach(function (el) { el.hidden = !sale; el.textContent = '-' + pctNow + '%'; });
      var sn = root.querySelector('[data-sticky-name]'), onName = root.querySelector('.tier.is-on .tier__name');
      if (sn && onName) { var first = onName.childNodes[0], nm = (first && first.nodeType === 3 ? first.textContent : onName.textContent).trim(); sn.textContent = nm + (state.kids > 1 ? ' × ' + state.kids : ''); }
      root.querySelectorAll('[data-free-gifts]').forEach(function (el) { var fv = el.getAttribute('data-variant'); el.classList.toggle('is-off', !!fv && String(state.id) !== fv); });
      window.Groovd.reconvertCurrency();
    }

    root.querySelectorAll('.tier').forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.classList.contains('is-out')) return;
        var d = readTier(t);
        root.querySelectorAll('.tier').forEach(function (x) { x.classList.toggle('is-on', x === t); var r = x.querySelector('input'); if (r) r.checked = x === t; });
        state.id = d.id; state.qty = d.qty; state.price = d.price; state.compare = d.compare;
        input.value = d.id;
        if (t.closest('[data-mode="variants"]')) { var u = new URL(location.href); u.searchParams.set('variant', d.id); history.replaceState({}, '', u); }
        render();
      });
    });

    root.querySelectorAll('[data-kid]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.kids = Number(b.getAttribute('data-kid'));
        root.querySelectorAll('[data-kid]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
        render();
      });
    });

    root.querySelectorAll('[data-addon]').forEach(function (cb) {
      cb.addEventListener('change', function () { cb.closest('.pdp__addon').classList.toggle('is-on', cb.checked); render(); });
    });

    /* Add-on variant pills: the pick becomes the switch's variant (and price), the row picture follows, the switch turns on */
    root.querySelectorAll('[data-addon-var]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.pdp__addon'), cb = row && row.querySelector('[data-addon]');
        if (!cb || b.disabled) return;
        row.querySelectorAll('[data-addon-var]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        cb.value = b.getAttribute('data-addon-var'); cb.setAttribute('data-price', b.getAttribute('data-price'));
        /* the row (and its info popup) show the picked variant's price: sets of one add-on can cost very different amounts */
        var pr = Number(b.getAttribute('data-price')) || 0, cp = Number(b.getAttribute('data-compare')) || 0, sale = cp > pr;
        row.querySelectorAll('.pdp__addon-price, .pdp__ai-price').forEach(function (box) {
          var now = box.querySelector('.money:not(s)'), was = box.querySelector('s.money'), off = box.querySelector('.pill');
          if (now) now.textContent = fm(pr);
          if (was) { was.hidden = !sale; if (sale) was.textContent = fm(cp); }
          if (off) { off.hidden = !sale; if (sale) off.textContent = Math.round((cp - pr) * 100 / cp) + '% off'; }
        });
        var img = b.getAttribute('data-img'), pic = row.querySelector('.pdp__addon-img img');
        if (img && pic) { pic.removeAttribute('srcset'); pic.src = img; }
        if (!cb.disabled && !cb.checked) cb.checked = true;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* Add-on popup: its button flips the row's switch */
    root.querySelectorAll('[data-addon-toggle]').forEach(function (b) {
      var cb = root.querySelector('[data-addon][value="' + b.getAttribute('data-addon-toggle') + '"]');
      if (!cb) { b.hidden = true; return; }
      function label() { b.textContent = cb.checked ? b.getAttribute('data-on') : b.getAttribute('data-off'); b.classList.toggle('is-on', cb.checked); }
      label();
      cb.addEventListener('change', label);
      b.addEventListener('click', function () {
        if (cb.disabled) return;
        cb.checked = !cb.checked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
        var d = b.closest('dialog');
        if (d && cb.checked) d.close();
      });
    });

    /* Show all add-ons: unfold the extra rows in place */
    root.querySelectorAll('[data-addons-more]').forEach(function (b) {
      var more = root.querySelectorAll('.pdp__addon--more'), label = b.querySelector('span') || b, base = label.textContent, open = false;
      b.addEventListener('click', function () {
        open = !open;
        more.forEach(function (m) { m.hidden = !open; });
        label.textContent = open ? b.getAttribute('data-less') : base;
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    /* Real-life images popup: tabs filter the photos */
    root.querySelectorAll('.pdp__rl').forEach(function (dlg) {
      var tabs = dlg.querySelectorAll('[data-rl-tab]'), items = dlg.querySelectorAll('[data-rl]'), list = dlg.querySelector('[data-rl-list]');
      function show(t) {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x.getAttribute('data-rl-tab') === t ? 'true' : 'false'); });
        items.forEach(function (it) { var k = it.getAttribute('data-rl'); it.hidden = !!(t && k && k !== t); });
        if (list) list.scrollTop = 0;
      }
      tabs.forEach(function (x) { x.addEventListener('click', function () { show(x.getAttribute('data-rl-tab')); }); });
      if (tabs.length) show(tabs[0].getAttribute('data-rl-tab'));
    });

    /* Colour bubbles: swap every quantity row to the chosen colour's variant, keep the chosen quantity. */
    var swRoot = root.querySelector('[data-swatch-root]');
    if (swRoot) {
      var cidx = Number(swRoot.getAttribute('data-cidx')), qidx = Number(swRoot.getAttribute('data-qidx'));
      swRoot.querySelectorAll('[data-sw]').forEach(function (b) {
        b.addEventListener('click', function () {
          var color = b.getAttribute('data-sw');
          if (swRoot.hasAttribute('data-single')) {
            var sv = variants.find(function (x) { return x.id === Number(b.getAttribute('data-vid')); });
            if (!sv || !sv.available) return;
            swRoot.querySelectorAll('[data-sw]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
            var sn = swRoot.querySelector('[data-sw-name]'); if (sn) sn.textContent = color;
            state.id = sv.id; state.qty = 1; state.price = sv.price; state.compare = sv.compare_at_price || 0; input.value = sv.id;
            var su = new URL(location.href); su.searchParams.set('variant', sv.id); history.replaceState({}, '', su);
            render();
            var ss = Number(b.getAttribute('data-slide-to')); if (ss > 0) go(ss - 1);
            return;
          }
          swRoot.querySelectorAll('[data-sw]').forEach(function (x) { var on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          var nm = swRoot.querySelector('[data-sw-name]'); if (nm) nm.textContent = color;
          swRoot.querySelectorAll('.tier').forEach(function (row) {
            var q = row.getAttribute('data-qval');
            var v = variants.find(function (x) { return x.options[cidx] === color && x.options[qidx] === q; });
            if (!v) return;
            var u = Number(row.getAttribute('data-units')) || 1;
            row.setAttribute('data-id', v.id); row.setAttribute('data-price', v.price);
            row.setAttribute('data-compare', v.compare_at_price || 0); row.setAttribute('data-available', v.available ? 'true' : 'false');
            row.classList.toggle('is-out', !v.available);
            var inp = row.querySelector('input'); if (inp) { inp.value = v.id; inp.disabled = !v.available; }
            var pe = row.querySelector('.tier__price .money'); if (pe) pe.textContent = fm(Math.floor(v.price / u));
            var ne = row.querySelector('.tier__note .money'); if (ne) ne.textContent = fm(v.price);
          });
          var on = swRoot.querySelector('.tier.is-on:not(.is-out)') || swRoot.querySelector('.tier:not(.is-out)');
          if (on) on.click();
          var sl = Number(b.getAttribute('data-slide-to')); if (sl > 0) go(sl - 1);
        });
      });
    }

    /* Delivery window, computed from today. */
    /* gw-units.js: US "Oct 12" and "10/31/2026", everyone else "12 Oct" and "31/10/2026" */
    function fmtDate(d, o) { return window.gwLocale ? window.gwLocale.date(d, o) : d.toLocaleDateString('en-US', o); }
    function paintDelivery() {
      root.querySelectorAll('[data-delivery]').forEach(function (el) {
        var min = Number(el.getAttribute('data-min')), max = Number(el.getAttribute('data-max')), biz = el.getAttribute('data-business') === 'true';
        function add(n) { var d = new Date(), k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (biz && (d.getDay() === 0 || d.getDay() === 6)) continue; k++; } return d; }
        /* with the weekday: "Tue, Oct 20" (US) / "Tue 20 Oct" (rest), like the lander's "Arrives between" line */
        var o = el.getAttribute('data-weekday') === 'true' ? { weekday: 'short', day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short' };
        el.querySelector('[data-from]').textContent = fmtDate(add(min), o);
        el.querySelector('[data-to]').textContent = fmtDate(add(max), o);
      });
    }
    paintDelivery();
    document.addEventListener('gw:locale', paintDelivery);
    /* gw-currency.js changed the currency (IP country or the live rate arrived): repaint the prices */
    document.addEventListener('gv:currency', render);

    /* Gifts: hide after their end date, keep the count and the earliest date true. */
    var gifts = root.querySelector('[data-gifts]');
    if (gifts) {
      var today = new Date(); today.setHours(0, 0, 0, 0); var live = 0, soon = null;
      gifts.querySelectorAll('[data-gift]').forEach(function (g) {
        var e = g.getAttribute('data-ends'); var d = e ? new Date(e + 'T23:59:59') : null;
        if (d && d < today && gifts.getAttribute('data-hide-expired') === 'true') { g.hidden = true; return; }
        live++; if (d && (!soon || d < soon)) soon = d;
      });
      var c = gifts.querySelector('[data-gift-count]'); if (c) c.textContent = live;
      var p = gifts.querySelector('[data-gift-ends]');
      var paintEnds = function () { if (p && soon) p.querySelector('[data-gift-ends-text]').textContent = fmtDate(soon, { month: '2-digit', day: '2-digit', year: 'numeric' }); };
      if (p) { if (soon) paintEnds(); else p.hidden = true; }
      document.addEventListener('gw:locale', paintEnds);
      if (!live) gifts.hidden = true;
    }

    /* Submit */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btns = root.querySelectorAll('[data-atc]'), err = root.querySelector('[data-err]');
      if (btns[0].getAttribute('aria-busy') === 'true') return;
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      if (err) err.hidden = true;
      /* PDP test (23.10.2026, layout/theme.liquid split): the visitor's half rides on the main line itself (_pdp, hidden), so an
         in-app browser that loses the follow-up attribute call still carries it; pdp_test also goes on the order below */
      var pdpArm = window.gvPdpArm ? window.gvPdpArm + (window.gvPdpQa ? '_qa' : '') : '';
      var items = [{ id: state.id, quantity: state.qty * state.kids }];
      if (pdpArm) items[0].properties = { _pdp: pdpArm };
      /* extras picked here are tagged _addon (hidden): they don't count toward free shipping on 2+ items (owner 27.10.2026: "if someone
         adds copybooks + cursive - it shouldn't ship free yet"); the same product added in the cart does */
      root.querySelectorAll('[data-addon]:checked').forEach(function (cb) { items.push({ id: Number(cb.value), quantity: 1, properties: { _addon: 'pdp' } }); });
      root.querySelectorAll('[data-gift][data-auto="true"]:not([hidden])').forEach(function (g) { items.push({ id: Number(g.getAttribute('data-variant')), quantity: 1 }); });
      /* free gifts (17.10.2026): $0 no-ship lines, one per set ("once" = one per order); the cart guard keeps them in step.
         Split test (18.10.2026): only a box for everyone or for this visitor's arm counts (layout/theme.liquid) */
      var arm = document.documentElement.getAttribute('data-gv-gifts') || '', fgBox = null;
      root.querySelectorAll('[data-free-gifts]').forEach(function (el) { var a = el.getAttribute('data-gv-arm'); if (!fgBox && (!a || a === arm)) fgBox = el; });
      if (fgBox && !fgBox.classList.contains('is-off')) {
        try { var gl = []; JSON.parse(fgBox.getAttribute('data-gift-items') || '[]').forEach(function (g) { if (g.id) gl.push({ id: Number(g.id), quantity: g.per === 'once' ? 1 : state.qty * state.kids, properties: { _gift: g.per === 'once' ? 'once' : 'set' } }); }); items = gl.reverse().concat(items); } catch (e2) {}
      }
      window.Groovd.addToCart(items, { replace: root.getAttribute('data-replace-cart') === 'true' })
        /* split test: the order carries the visitor's arm (Additional details, gifts_test) */
        .then(function () { var at = {}, pa = document.documentElement.getAttribute('data-gv-price') || ''; if (arm) at.gifts_test = arm; if (pa && root.hasAttribute('data-bs-ok')) at.price_test = pa; if (pdpArm) at.pdp_test = pdpArm; if (!Object.keys(at).length) return; return fetch(window.routes.cart_update_url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: at }) })['catch'](function () {}); })
        .then(function () { window.Groovd.goAfterAdd(root.getAttribute('data-after-add')); })
        .catch(function (x) { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); if (err) { err.textContent = (x && (x.description || x.message)) || 'Could not add to cart. Please try again.'; err.hidden = false; } });
    });

    /* Gallery: dots, arrows, thumbs, tiles. The dots are buttons (Paulina 21.10.2026: clicking them did nothing on a
       computer), so the [data-goto] binding below drives them; they stay out of the Tab order, the arrows serve keyboards. */
    var track = root.querySelector('[data-track-hero]');
    var slides = track ? track.querySelectorAll('[data-slide]') : [];
    var dotsWrap = root.querySelector('[data-dots]');
    var arrows = root.querySelectorAll('.pdp__arrow');
    var cur = 0;
    if (slides.length > 1 && dotsWrap) {
      slides.forEach(function (s, k) {
        var d = document.createElement('button');
        d.type = 'button'; d.tabIndex = -1;
        d.setAttribute('data-goto', k); d.setAttribute('aria-label', 'Show image ' + (k + 1));
        dotsWrap.appendChild(d);
      });
    }
    /* Speed (Kimmo 19.10.2026): slides 2+ arrive without src so they don't compete with the main photo. The next slide is
       always ready: slide 2 loads as soon as the main photo has loaded, and showing slide i loads slides i and i+1. */
    function wake(i) {
      var s = slides[i], im = s && s.querySelector('img[data-srcset], img[data-src]');
      if (!im) return;
      im.loading = 'eager';
      if (im.getAttribute('data-srcset')) im.setAttribute('srcset', im.getAttribute('data-srcset'));
      if (im.getAttribute('data-src')) im.setAttribute('src', im.getAttribute('data-src'));
      im.removeAttribute('data-srcset'); im.removeAttribute('data-src');
    }
    if (slides.length > 1) {
      var firstImg = slides[0].querySelector('img');
      if (!firstImg || firstImg.complete) wake(1);
      else { firstImg.addEventListener('load', function () { wake(1); }, { once: true }); firstImg.addEventListener('error', function () { wake(1); }, { once: true }); }
    }
    function go(i) { wake(i); wake(i + 1); var s = slides[i]; if (s) track.scrollTo({ left: s.offsetLeft, behavior: 'smooth' }); }
    function mark(moved) {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      cur = i;
      if (moved) { wake(i); wake(i + 1); }
      dotsWrap && dotsWrap.querySelectorAll('button').forEach(function (d, k) { d.setAttribute('aria-current', k === i); });
      root.querySelectorAll('.pdp__thumb').forEach(function (d, k) { d.setAttribute('aria-current', k === i); });
      arrows.forEach(function (a) { var to = i + Number(a.getAttribute('data-step')); a.hidden = to < 0 || to >= slides.length; });
    }
    if (track) { track.addEventListener('scroll', function () { window.requestAnimationFrame(function () { mark(true); }); }, { passive: true }); mark(); }
    root.querySelectorAll('[data-goto]').forEach(function (b) { b.addEventListener('click', function () { go(Number(b.getAttribute('data-goto'))); if (b.classList.contains('pdp__tile')) root.querySelector('.pdp__hero').scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }); });
    arrows.forEach(function (a) { a.addEventListener('click', function () { go(cur + Number(a.getAttribute('data-step'))); }); });

    /* Rated card popup */
    root.querySelectorAll('[data-modal-open]').forEach(function (b) {
      var dlg = document.getElementById(b.getAttribute('data-modal-open'));
      if (!dlg || typeof dlg.showModal !== 'function') { b.hidden = true; return; }
      b.addEventListener('click', function () { dlg.showModal(); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-modal-close]')) dlg.close(); });
    });

    /* Sticky bar whenever the main button is off screen (above or below), like hlthtrack.com; slides away while it shows */
    var sticky = root.querySelector('[data-sticky]'), main = form.querySelector('[data-atc]');
    if (sticky && main) {
      /* a scroll listener, not an IntersectionObserver: a jump back to the top must hide it again */
      var tick = false;
      /* offer style (lander rule): only once the main button has scrolled past the top; total style: whenever it is off screen */
      var offerBar = sticky.getAttribute('data-sticky') === 'offer';
      var check = function () {
        tick = false;
        var r = main.getBoundingClientRect(), off = offerBar ? r.bottom < 0 : !(r.bottom > 0 && r.top < window.innerHeight);
        var on = off && !(r.width === 0 && r.height === 0);
        if (on === sticky.classList.contains('is-on')) return;
        sticky.classList.toggle('is-on', on);
        if (on) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      };
      /* room under the footer so the bar never covers the end of the page */
      var pad = function () { document.body.style.paddingBottom = sticky.offsetHeight + 'px'; };
      window.addEventListener('scroll', function () { if (!tick) { tick = true; window.requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', function () { pad(); check(); });
      pad(); check();
    }
    render();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-mosaic"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-video-tile]').forEach(function (tile) {
  var btn = tile.querySelector('[data-play]'), v = tile.querySelector('video');
  if (!btn) return;
  if (!v) { btn.hidden = true; return; }
  btn.addEventListener('click', function () {
    document.querySelectorAll('[data-video-tile] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('[data-video-tile]').classList.remove('is-playing'); } });
    v.controls = true; v.play(); tile.classList.add('is-playing');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rv]').forEach(function (root) {
  var list = root.querySelector('[data-list]'); if (!list) return;
  var cards = Array.prototype.slice.call(list.querySelectorAll('[data-i]'));
  var st = { f: 'all', q: '', sort: 'high', all: false };
  var per = cards.filter(function (c) { return !c.hasAttribute('data-more-hidden'); }).length;
  function apply() {
    var sorted = cards.slice().sort(function (a, b) {
      var ra = +a.dataset.r, rb = +b.dataset.r, pa = +a.dataset.p, pb = +b.dataset.p, ia = +a.dataset.i, ib = +b.dataset.i;
      if (st.sort === 'low') return ra - rb || ia - ib;
      if (st.sort === 'photos') return (pb > 0) - (pa > 0) || ia - ib;
      return rb - ra || ia - ib;
    });
    var shown = 0, matched = 0;
    sorted.forEach(function (c) {
      var ok = st.f === 'all' ? true : st.f === 'photos' ? +c.dataset.p > 0 : +c.dataset.r === +st.f;
      if (ok && st.q) ok = c.textContent.toLowerCase().indexOf(st.q) > -1;
      if (ok) matched++;
      var vis = ok && (st.all || st.f !== 'all' || st.q || matched <= per);
      c.hidden = !vis; if (vis) shown++;
      list.appendChild(c);
    });
    var s = root.querySelector('[data-shown]'); if (s) s.textContent = shown;
    root.querySelector('[data-empty]').hidden = matched > 0;
  }
  root.querySelectorAll('[data-filter]').forEach(function (b) { b.addEventListener('click', function () { st.f = b.dataset.filter; root.querySelectorAll('.rv__chip').forEach(function (c) { c.classList.toggle('is-on', c.dataset.filter === st.f); c.setAttribute('aria-pressed', c.dataset.filter === st.f ? 'true' : 'false'); }); apply(); }); });
  var q = root.querySelector('[data-q]'); if (q) q.addEventListener('input', function () { st.q = q.value.trim().toLowerCase(); apply(); });
  var so = root.querySelector('[data-sort]'); if (so) so.addEventListener('change', function () { st.sort = so.value; apply(); });
  function clamps() { root.querySelectorAll('[data-clamp]').forEach(function (p) { var b = p.nextElementSibling; if (!b || p.classList.contains('is-open')) return; b.hidden = p.scrollHeight <= p.clientHeight + 2; }); }
  root.addEventListener('click', function (e) { var b = e.target.closest('[data-readmore]'); if (!b) return; var p = b.previousElementSibling; p.classList.add('is-open'); b.hidden = true; });
  var more = root.querySelector('[data-more]'); if (more) more.addEventListener('click', function () { per += 6; apply(); if (per >= cards.length) more.hidden = true; });
  var dlg = root.querySelector('[data-lbox]'), img = root.querySelector('[data-lbox-img]');
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lb]');
    if (b && dlg.showModal) { img.src = b.dataset.lb; dlg.showModal(); }
    if (e.target.closest('[data-lbox-close]') || e.target === dlg) dlg.close();
  });
  apply(); clamps();
  root.querySelectorAll('[data-filter],[data-more]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(clamps, 30); }); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specialist-picks"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.sp20'); if(!root) return;
  [].forEach.call(root.querySelectorAll('.gal'),function(g){var tr=g.querySelector('.gtrack'),th=[].slice.call(g.querySelectorAll('.gt')),ct=g.querySelector('.gcount'),n=th.length;
    function cur(){return Math.round(tr.scrollLeft/Math.max(1,tr.clientWidth));}
    function mark(){var c=Math.min(n-1,cur());th.forEach(function(t,i){t.classList.toggle('on',i===c);t.setAttribute('aria-current',i===c?'true':'false');});if(ct)ct.textContent=(c+1)+'/'+n;}
    th.forEach(function(t,i){t.addEventListener('click',function(){tr.scrollTo({left:i*tr.clientWidth,behavior:'smooth'});});});
    var tm;tr.addEventListener('scroll',function(){clearTimeout(tm);tm=setTimeout(mark,80);},{passive:true});});
  /* Ad tags ride along on every buy link (the CheckoutChamp pages need them to credit the order), as on the gift-guide page. */
  var KEYS=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','ttclid'],keep=[],qs=location.search.replace(/^\?/,'');
  if(qs){qs.split('&').forEach(function(kv){if(KEYS.indexOf(kv.split('=')[0])>-1)keep.push(kv);});}
  var store=null;try{store=window.sessionStorage;}catch(e){}
  if(keep.length){try{store&&store.setItem('sp20_qs',keep.join('&'));}catch(e){}}else{try{var sv=store&&store.getItem('sp20_qs');if(sv)keep=sv.split('&');}catch(e){}}
  var tail=keep.join('&');
  function add(a){if(!tail)return;var h=a.getAttribute('href');if(!h||h.charAt(0)==='#'||h.indexOf('mailto:')===0)return;var x=h.indexOf('#'),b=x>-1?h.slice(0,x):h,f=x>-1?h.slice(x):'';a.setAttribute('href',b+(b.indexOf('?')>-1?'&':'?')+tail+f);}
  var ctas=root.querySelectorAll('a[data-cta]');for(var i=0;i<ctas.length;i++)add(ctas[i]);
  /* The checkout site starts PostHog with this visitor's ids, so the article read and the purchase are one person. */
  function ids(a){try{if(a.hostname!=='checkout.thegroovd.com')return;if(!window.posthog||!posthog.get_distinct_id)return;var h=a.getAttribute('href')||'';if(h.indexOf('ph_did=')>-1)return;var re=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;var d=posthog.get_distinct_id(),s=posthog.get_session_id?posthog.get_session_id():'';if(!d||!re.test(d))return;var p='ph_did='+d+(s&&re.test(s)?'&ph_sid='+s:'');var x=h.indexOf('#'),b=x>-1?h.slice(0,x):h,f=x>-1?h.slice(x):'';a.setAttribute('href',b+(b.indexOf('?')>-1?'&':'?')+p+f);}catch(e){}}
  for(var j=0;j<ctas.length;j++){ctas[j].addEventListener('click',function(ev){var a=ev.currentTarget;ids(a);var d={guide:a.getAttribute('data-guide'),rank:a.getAttribute('data-rank'),product:a.getAttribute('data-product')};
    if(window.fbq){try{fbq('trackCustom','GuideCTAClick',d);}catch(e){}}
    if(window.posthog&&posthog.capture){try{d.to=a.hostname;posthog.capture('guide_cta_click',d);}catch(e){}}});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-wall"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vw [data-video-tile]').forEach(function (tile) {
  var btn = tile.querySelector('[data-play]'), v = tile.querySelector('video');
  if (!btn) return;
  if (!v) { btn.hidden = true; return; }
  btn.addEventListener('click', function () {
    document.querySelectorAll('[data-video-tile] video').forEach(function (o) { if (o !== v) { o.pause(); var t = o.closest('[data-video-tile]'); t && t.classList.remove('is-playing'); } });
    v.controls = true; v.play(); tile.classList.add('is-playing');
  });
});

  } catch(e) { console.error(e); }
})();
})();
